<script>
	import { createEventDispatcher } from "svelte";
	import { locateID } from "@xbs/lib-dom";
	import { isSameId } from "@xbs/lib-todo";

	export let options = [];

	$: selected = options.find(i => i.icon === "check")?.id;

	const dispatch = createEventDispatcher();

	const click = event => {
		selected = locateID(event, "data-list-id");
		dispatch("click", {
			id: selected,
		});
	};

	const selection = event => {
		const index = options.findIndex(i => isSameId(i.id, selected));
		let nextSelection;
		switch (event.code) {
			case "ArrowUp":
				event.preventDefault();
				nextSelection = options[index - 1]?.id;
				selected =
					nextSelection !== undefined
						? nextSelection
						: options.at(-1).id;
				break;
			case "ArrowDown":
				event.preventDefault();
				nextSelection = options[index + 1]?.id;
				selected =
					nextSelection !== undefined ? nextSelection : options[0].id;
				break;
			case "Enter":
				event.preventDefault();
				if (selected === undefined) return;
				dispatch("click", { id: selected });
				break;
		}
	};

</script>

<svelte:window on:keydown={selection} />

<ul class="wx-todo_list" on:click={click}>
	{#each options as item (item.id)}
		<li
			class="wx-todo_list__item"
			class:wx-todo_list__item--selected={isSameId(item.id, selected)}
			data-list-id={item.id}>
			<slot {item} />
		</li>
	{/each}
</ul>

<style>
	.wx-todo_list {
		overflow: auto;
	}
	.wx-todo_list,
	.wx-todo_list__item {
		list-style: none;
		margin: 0;
		padding: 0;
	}
	.wx-todo_list__item:hover,
	.wx-todo_list__item--selected {
		background: var(--wx-background-selected);
	}

</style>
